module.exports = __webpack_public_path__ + "fonts/icomoon.e71ab6dc.7085178.woff";